// ErrorBoundary.js
import React from 'react';
import { analytics, logEvent } from './firebase';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('🔥 React Component Crash:', error, info);

        logEvent(analytics, 'web_react_component_error', {
            message: error.toString(),
            stack: error.stack,
            componentStack: info.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return <h2>Oops! Something went wrong.</h2>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;